import { t } from "i18next";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import FilterableTableLayout from "../../../components/FilterableTableLayout/FilterableTableLayout";
import { PersistedFilterKeys } from "../../../modules/filters/filters.types";
import { useTrademarkList } from "../../../modules/obligee/records/records.queries";
import {
  getProductionCodeRequestFilterItems,
  getProductionCodeRequestTableColumns,
  PRODUCTION_CODE_REQUEST_INITIAL_FILTERS,
} from "../../../modules/productionCode/productionCode.constants";
import { useProductionCodeRequestList } from "../../../modules/productionCode/productionCode.queries";
import {
  ProductionCodeRequest,
  ProductionCodeRequestListPayload,
} from "../../../modules/productionCode/productionCode.types";
import style from "./ProductionCodeRequestListPage.module.scss";
interface ProductionCodeRequestListProps {
  isMfin?: boolean;
}
const ProductionCodeRequestList = ({
  isMfin,
}: ProductionCodeRequestListProps) => {
  const navigate = useNavigate();

  const { data: trademarks, isLoading: isLoadingTrademarks } = useTrademarkList(
    {
      filters: {
        naziv: null,
      },
    }
  );

  const hiddenFilters = useMemo(() => {
    return isMfin
      ? []
      : (["pib"] as Array<keyof ProductionCodeRequestListPayload>);
  }, [isMfin]);

  const hiddenColumns = useMemo(() => {
    return isMfin
      ? []
      : (["pib", "drustvo"] as Array<keyof ProductionCodeRequest>);
  }, [isMfin]);

  const onTableRowClickHandler = (record: ProductionCodeRequest) => {
    navigate(
      `/${
        isMfin ? "mfin/produkcioniKodovi" : "obveznik/produkcioniKodovi"
      }/pregledZahteva?id=${record.id}`
    );
  };

  return (
    <FilterableTableLayout<
      ProductionCodeRequest,
      Array<ProductionCodeRequest>,
      ProductionCodeRequestListPayload
    >
      tableName="production_code_request_table"
      toolbarId="production_code_request_list"
      title={t("QR_CODE.LISTA_ZAHTEVA_ZA_PRODUKCIONE_KODOVE")}
      tableRowKey="id"
      getTableColumns={() =>
        getProductionCodeRequestTableColumns({
          hiddenColumns,
        })
      }
      queryHook={useProductionCodeRequestList}
      filterProps={{
        triggerQueryManually: true,
        getFilterItems: () =>
          getProductionCodeRequestFilterItems({
            trademarks,
            hiddenFilters,
            isLoadingTrademarks,
          }),
        initialFilters: PRODUCTION_CODE_REQUEST_INITIAL_FILTERS,
        persistedFilterKey: PersistedFilterKeys.PRODUCTION_CODE_REQUEST_LIST,
        filterToolbarClassName: !isMfin ? style.filterToolbar : "",
      }}
      onTableRowClick={onTableRowClickHandler}
    />
  );
};

export default ProductionCodeRequestList;
